import { Component, OnInit } from '@angular/core';
import { IFeaturesService } from '../../services/iFeatures.service';
import { Router } from '@angular/router';
import { Features } from '../../models/models';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-jobs-redirect',
    templateUrl: './jobs-redirect.component.html',
    styleUrls: ['./jobs-redirect.component.css'],
    standalone: false
})
export class JobsRedirectComponent implements OnInit {

  constructor(
    private _featuresService: IFeaturesService,
    private _router: Router) { }

  ngOnInit() {
    this.isCompanyAdministrationEnabled().then(enabled => {
      if (enabled) {
        this._router.navigate(['/jobs2']);
      } else {
        this._router.navigate(['/jobs']);
      }
    });
  }

  async isCompanyAdministrationEnabled(): Promise<boolean> {
    return await firstValueFrom(this._featuresService.isFeatureEnabled(Features.CompanyAdministration));
  }

}
